import { render, staticRenderFns } from "./overseasItem.vue?vue&type=template&id=03ff24ab&scoped=true"
import script from "./overseasItem.vue?vue&type=script&lang=js"
export * from "./overseasItem.vue?vue&type=script&lang=js"
import style0 from "./overseasItem.vue?vue&type=style&index=0&id=03ff24ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ff24ab",
  null
  
)

export default component.exports